import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { useMaterialUIController, setLayout } from "context";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import Illustration from "application/modules/authentication/sign-in";

function CTLDashboardLayout({ children }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(
      dispatch,
      AuthenticationService.isAuthenticated() ? "dashboard" : "page"
    );
  }, [pathname]);

  const pageType = AuthenticationService.getKeyTypePage();

  return AuthenticationService.isAuthenticated() ? (
    <MDBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => {
        const baseStyles = {
          pt: 0,
          pl: 1,
          pr: 1,
          pb: 3,
          position: "relative",
        };

        if (pageType === false) {
          baseStyles[breakpoints.up("sm")] = {
            marginLeft: miniSidenav ? pxToRem(64) : pxToRem(64),
            transition: transitions.create(["margin-left", "margin-right"], {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.standard,
            }),
          };
        }

        return baseStyles;
      }}
    >
      {children}
    </MDBox>
  ) : (
    <Illustration />
  );
}

CTLDashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CTLDashboardLayout;
